import { useState } from 'react';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import { visibleLanguages } from 'src/config/quill-text-editor-settings';
import { CompetitionFormControl } from '../form/CompetitionFormControl';

export default function TeamDialog(props: any) {
  const [team, setTeam] = useState(props?.team);

  const handleChangeTeamField = (e: any) => {
    setTeam((prevState: any) => ({
      ...prevState,
      [e.target?.id]: e.target?.value,
    }));
  };

  const handleCompetitionChange = (competitionId: number) => {
    setTeam((prevState: any) => ({
      ...prevState,
      competition_id: competitionId,
    }));
  };

  const handleCancel = () => {
    props.onClose();
  };

  const handleSave = () => {
    props.onSave(team);
  };

  return (
    <Dialog
      open={true}
      onClose={() => {}}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle id='alert-dialog-title'>
        {team ? 'Edit Team' : 'Create Team'}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12} mt={1}>
            <CompetitionFormControl
              value={team?.competition_id}
              onChange={(event: any) =>
                handleCompetitionChange(event.target.value)
              }
            />
          </Grid>

          {visibleLanguages.map((lang) => (
            <Grid item xs={6}>
              <TextField
                id={`name_${lang.code}`}
                label={`Name ${lang.label}`}
                variant='standard'
                value={team?.[`name_${lang.code}`] || ''}
                onChange={handleChangeTeamField}
              />
            </Grid>
          ))}

          <Grid item xs={6}>
            <TextField
              required
              id='team_feed_id'
              label='Team Feed Id'
              variant='standard'
              value={team?.team_feed_id || ''}
              onChange={handleChangeTeamField}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleCancel()}>Cancel</Button>
        <Button onClick={() => handleSave()} autoFocus>
          {team ? 'Save' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
